var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_383_55)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#3498DB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 8.5,
    width: 41,
    height: 41,
    rx: 20.5,
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2083 29.0001C35.1343 29.0001 36.9814 28.2319 38.3433 26.8644C39.7051 25.4969 40.4702 23.6423 40.4702 21.7084C40.4702 19.7745 39.7051 17.9199 38.3433 16.5524C36.9814 15.185 35.1343 14.4167 33.2083 14.4167C31.2824 14.4167 29.4353 15.185 28.0734 16.5524C26.7115 17.9199 25.9464 19.7745 25.9464 21.7084C25.9464 23.6423 26.7115 25.4969 28.0734 26.8644C29.4353 28.2319 31.2824 29.0001 33.2083 29.0001ZM27.7619 32.1446C23.5636 33.3808 20.5 37.2773 20.5 41.8915C20.5 42.8258 21.2546 43.5834 22.185 43.5834H44.2317C45.9167 43.5834 45.9167 43.5834 45.9167 41.8915C45.9167 37.2773 42.8531 33.3808 38.6548 32.1446V35.0385C40.2206 35.443 41.378 36.8728 41.378 38.5704V40.849C41.378 41.3503 40.9695 41.7605 40.4702 41.7605H39.5625C39.0632 41.7605 38.6548 41.3503 38.6548 40.849C38.6548 40.3477 39.0632 39.9376 39.5625 39.9376V38.5704C39.5625 37.5621 38.7512 36.7475 37.747 36.7475C36.7428 36.7475 35.9315 37.5621 35.9315 38.5704V39.9376C36.4308 39.9376 36.8393 40.3477 36.8393 40.849C36.8393 41.3503 36.4308 41.7605 35.9315 41.7605H35.0238C34.5246 41.7605 34.1161 41.3503 34.1161 40.849V38.5704C34.1161 36.8728 35.2734 35.443 36.8393 35.0385V31.7857C36.4989 31.7515 36.1528 31.7345 35.8011 31.7345H30.6156C30.2639 31.7345 29.9178 31.7515 29.5774 31.7857V35.5113C30.8879 35.9044 31.8467 37.1235 31.8467 38.5704C31.8467 40.3306 30.4227 41.7605 28.6696 41.7605C26.9166 41.7605 25.4926 40.3306 25.4926 38.5704C25.4926 37.1235 26.4514 35.9044 27.7619 35.5113V32.1446ZM28.6696 39.9376C29.0308 39.9376 29.3771 39.7935 29.6324 39.5371C29.8878 39.2807 30.0313 38.933 30.0313 38.5704C30.0313 38.2078 29.8878 37.86 29.6324 37.6036C29.3771 37.3472 29.0308 37.2032 28.6696 37.2032C28.3085 37.2032 27.9622 37.3472 27.7068 37.6036C27.4515 37.86 27.308 38.2078 27.308 38.5704C27.308 38.933 27.4515 39.2807 27.7068 39.5371C27.9622 39.7935 28.3085 39.9376 28.6696 39.9376Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_383_55",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_383_55"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_383_55",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_383_55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.0952e10d1240c2e6423525f29c0a3870.svg";
export { ForwardRef as ReactComponent };